
/**
 * @typedef {Object} TooltipParams
 * @property {Object[]} params - Params from formatter function
 * @property {boolean} [formatByIndex=false] - Whether the formatAxisValueFn will receive the index of the data (true) or the label (false).
 * @property {function(): string} [formatAxisValueFn] - Optional function to format the axis value.
 * @property {number} [valueIndex=1] - Index of the actual value in the value array. Default is 1.
 * @property {function(): string | function(): string[]} [formatFn] - Optional array of functions to format the values of each series OR one function to format them all.
 */

/**
 * Function to create a tooltip with its title and each series value formatted.
 * Use it when you need to format the axisValue. Otherwise, each value can be formatted from the graph configuration.
 *
 * @param {TooltipParams} param - Configuration object for the tooltip.
 * @returns {string} - The formatted tooltip string.
 */
const multiTooltip = ({ params, formatByIndex = false, formatAxisValueFn, valueIndex = 1, formatFn }) => {
    if (!params || !params.length == 0);

    const { axisValue, value } = params[0];
    let axisTitle = axisValue
    if (formatAxisValueFn) {
        axisTitle = formatAxisValueFn(formatByIndex ? value[0] : axisValue)
    }

    let str = `<div class="dashboard-multi-tooltip">${axisTitle}`

    for (let index = 0; index < params.length; index++) {
        const param = params[index];
        const { seriesName, value, marker } = param;
        let valueShown = value[valueIndex];

        if (formatFn) {
            if (Array.isArray(formatFn)) {
                valueShown = formatFn[index](valueShown)
            } else {
                valueShown = formatFn(valueShown)
            }
        }

        str += `<br/>${marker} ${seriesName}: <strong>${valueShown}</strong>`;
    }
    return `${str}</div>`
}

export default multiTooltip;